export enum BetType {
    DTBTie,
    DTBDragonWin,
    DTBTigerWin,

    DTBDragonBig,
    DTBDragonSmall,
    DTBDragonOdd,
    DTBDragonEven,
    DTBDragonRed,
    DTBDragonBlack,

    DTBTigerBig,
    DTBTigerSmall,
    DTBTigerOdd,
    DTBTigerEven,
    DTBTigerRed,
    DTBTigerBlack,

    DTBMaxBet,
}
